<template>
  <div class="user-nav level">
    <div class="level-left">
      <a class="button" @click="goBack">
        <span class="icon is-small">
          <i class="material-icons">&#xE317;</i>
        </span>
        <span>{{ $t('user.nav.back') }}</span>
      </a>
      <div
        class="user-id"
        :class="{ 'is-active': activeRoute === 'audience-user' }"
      >
        {{ $t('user.nav.user_id') }}: {{ userId }}
      </div>
      <span class="separator" v-if="tripStart">
        <i class="material-icons">&#xE5CC;</i>
      </span>
      <div class="trip-start tag is-rounded" v-if="tripStart">
        {{ $t('user.nav.car_trip') }} - {{ tripStart }}
        <button class="delete is-small" @click="goBack"></button>
      </div>
    </div>
    <div class="level-right">
      <language-switcher />
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import { mapState } from 'vuex';
import LanguageSwitcher from 'site/nav/LanguageSwitcher';

export default {
  name: 'UserNav',

  components: {
    LanguageSwitcher,
  },

  computed: {
    ...mapState('trip', ['start']),
    ...mapState('application', ['appId']),

    activeRoute() {
      return this.$route.name;
    },

    userId() {
      return this.$route.params.userId;
    },

    tripStart() {
      if (!this.$route.params.tripStart) {
        return;
      }

      const start = moment.parseZone(this.$route.params.tripStart);

      return start.format('h:mm a');
    },
  },

  methods: {
    goBack() {
      if (this.activeRoute === 'audience-trip') {
        const { userId } = this.$route.params;
        const day = moment.parseZone(this.start).format('YYYY-MM-DD');

        return this.$router.push({ name: 'audience-user', query: { day } });
      }

      return this.$router.push({
        name: 'audience',
        params: {
          appId: this.appId,
        },
        query: {
          view: this.$store.state.audience.activeBoardView,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.user-nav {
  position: relative;
  display: flex;
  align-items: center;
  height: 2.5rem;

  margin-bottom: 0;
  background-color: $white;
  box-shadow: 0 2px 12px 0 rgba($black, 0.06);
  padding-left: 3rem;
  padding-right: 3rem;

  &.is-dark {
    background-color: #0f0f0f;
    background: linear-gradient(to bottom, #1e1e1e 0%, #0f0f0f 100%);
  }
}

.button {
  // background-color: #d0d0d0;
  background-color: rgba($black, 0.04);
  padding: 0.6875rem 1.125rem;
  font-size: 0.6875rem;
  line-height: 1.125rem;
  letter-spacing: 2.3px;
  text-transform: uppercase;
  color: rgba($black, 87);
  border-radius: 0;
  border-left: 1px solid rgba($black, 0.08);
  border-right: 1px solid rgba($black, 0.08);

  .icon {
    font-size: 1rem;

    &:first-child {
      &:not(:last-child) {
        margin-left: 0;
        margin-right: 0.75rem;
      }
    }
  }
}

.user-id {
  // color: rgba($white, .4);
  color: rgba($black, 0.87);
  font-size: 0.875rem;
  margin-left: 1.5rem;

  &.is-active {
    // color: rgba($white, .72);
  }
}

.trip-start {
  margin-left: 1rem;
  background-color: $blue;
  color: $white;
}

.tag {
  font-size: 0.875rem;
  font-weight: $weight-medium;
}

.delete {
  background-color: $white;
  margin-left: 0.5rem !important;

  &::before,
  &::after {
    background-color: $blue;
  }

  &::before {
    height: 1px;
  }

  &::after {
    width: 1px;
  }
}

.separator {
  display: flex;
  margin-left: 1rem;

  i {
    font-size: 1.25rem;
    // color: rgba($white, .87);
    color: rgba($black, 0.87);
  }
}

.language-switcher {
  border-left: 1px solid rgba($black, 0.08);
}
</style>
